export default {
  name: "close_dialog",
  box: 18,
  svg: `<path
  d="M9.00061 9L12.9329 12.9322M5.06836 12.9322L9.00061 9L5.06836 12.9322ZM12.9329 5.06775L8.99986 9L12.9329 5.06775ZM8.99986 9L5.06836 5.06775L8.99986 9Z"
  stroke="black"
  stroke-width="1.5"
  stroke-linecap="round"
  stroke-linejoin="round"
/>`,
};
